import { StanButton, StanModal } from '@/components';
import { useDeleteFunnel } from '../../../queries/useFunnelMutations';

interface DeleteFunnelModalProps {
    isOpen: boolean;
    onClose: () => void;
    storeId: number;
    funnelName: string;
    onDeleted?: () => void;
}

/**
 * Confirmation modal for deleting a funnel.
 * Matches Vue DeleteStoreModal behavior.
 */
export const DeleteFunnelModal = ({ isOpen, onClose, storeId, funnelName, onDeleted }: DeleteFunnelModalProps) => {
    const deleteFunnel = useDeleteFunnel();

    const handleDelete = async () => {
        await deleteFunnel.mutateAsync(storeId);
        onDeleted?.();
        onClose();
    };

    return (
        <StanModal id='delete-funnel-modal' isOpen={isOpen} onClose={onClose} title='Delete Funnel'>
            <div className='flex flex-col gap-4'>
                <p className='text-body-md text-gray text-center'>
                    Are you sure you want to delete <strong className='text-dark'>{funnelName}</strong>? This action
                    cannot be undone.
                </p>
                <p className='text-body-sm text-gray text-center'>
                    <strong className='text-dark'>Legacy products</strong> attached to this funnel will be permanently
                    deleted. Products from your store will remain available in your store.
                </p>
                <div className='flex w-full gap-1 pt-2 max-sm:flex-col sm:gap-2'>
                    <StanButton name='cancel-delete-funnel' variant='outline' onClick={onClose} className='w-full'>
                        Cancel
                    </StanButton>
                    <StanButton
                        name='confirm-delete-funnel'
                        color='destructive'
                        onClick={handleDelete}
                        disabled={deleteFunnel.isPending}
                        className='w-full'
                    >
                        {deleteFunnel.isPending ? 'Deleting...' : 'Delete'}
                    </StanButton>
                </div>
            </div>
        </StanModal>
    );
};
